import { render, staticRenderFns } from "./NumeroDocumentoField.vue?vue&type=template&id=b2417000&scoped=true&"
import script from "./NumeroDocumentoField.vue?vue&type=script&lang=js&"
export * from "./NumeroDocumentoField.vue?vue&type=script&lang=js&"
import style0 from "./NumeroDocumentoField.vue?vue&type=style&index=0&id=b2417000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2417000",
  null
  
)

export default component.exports